import { isFreeProduct } from "../badge/FreeBadge";
import CatalogTileCard from "./CatalogTileCard";
import { resolveCatalogInstructor } from "./catalogInstructorDisplay";

export default function CatalogGridCard({
	to,
	title,
	imageUrl,
	showFreeBadge,
	product,
	actionLabel = "مشاهده",
	subtitle: subtitleProp,
	metaLine,
	metaSlot,
	instructorAvatarUrl: instructorAvatarUrlProp,
	subtitleMuted: subtitleMutedProp,
	imageSlot = null,
}) {
	const showBadge = showFreeBadge && product && isFreeProduct(product);
	const resolved = product ? resolveCatalogInstructor(product) : null;
	const subtitle = subtitleProp ?? resolved?.subtitle;
	const instructorAvatarUrl =
		instructorAvatarUrlProp ?? resolved?.avatarUrl;
	const subtitleMuted =
		subtitleMutedProp ?? Boolean(resolved?.isEmpty && !subtitleProp);

	return (
		<CatalogTileCard
			to={to}
			title={title}
			imageUrl={imageUrl}
			actionLabel={actionLabel}
			subtitle={subtitle}
			metaLine={metaLine}
			metaSlot={metaSlot}
			instructorItem={product}
			instructorAvatarUrl={instructorAvatarUrl}
			subtitleMuted={subtitleMuted}
			showFreeBadge={showBadge}
			imageSlot={imageSlot}
		/>
	);
}
